angular.module('contactModule', ['contactTemplates']);
